import { CloseOutlined, FilterAltOutlined } from "@mui/icons-material";
import {
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Stack,
  styled,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
  Link,
  Box,
  Drawer,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import { jobsApi } from "src/api/jobs";
import CustomCheckBox from "src/components/customCheckBox";
import HelperLink from "src/components/HelperLink";
import { HELP_URL } from "src/config";
import { AuthContext } from "src/contexts/auth/firebase-context";
import { useColorCodes } from "src/hooks/use-color-codes";
import getChipColor from "src/utils/get-chip-color";

const Filters = ({
  status,
  setStatus,
  provider,
  setProvider,
  campaigns,
  setCampaigns,
  setSelectedAccounts,
  providerOptions,
  statusOptions
}) => {
  const { user } = useContext(AuthContext);
  const theme = useTheme();
  const colorCodes = useColorCodes();
  const [tempStatus, setTempStatus] = useState(status);
  const [tempProvider, setTempProvider] = useState(provider);
  const [source, setSource] = useState("all");
  const [userCampaigns, setUserCampaigns] = useState([]);
  const [userCampaignsLoading, setUserCampaignsLoading] = useState(true);
  const [aiAgents, setaiAgents] = useState([]);
  const [selectedCampaigns, setSelectedCampaigns] = React.useState(campaigns);
  const [selectAll, setSelectAll] = useState(false);
  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // mailbox connection status filter handle
  const handleStatusChange = (event) => {
    setTempStatus(event.target.value);
  };

  const handleProviderChange = (event) => {
    setTempProvider(event.target.value);
  };
  const handleSourceChange = (event) => {
    setSource(event.target.value);
  };

  const handleSelectAll = () => {
    if (!selectAll) {
      setSelectedCampaigns([...userCampaigns]);
    } else {
      setSelectedCampaigns([]);
    }
    setSelectAll(!selectAll);
  };
  const handleCampaignChange = (event, newValue) => {
    if (newValue.some((item) => item.selectAll)) {
      handleSelectAll();
    } else {
      setSelectedCampaigns(newValue.filter((item) => !item.selectAll));
    }
  };

  const handleApply = () => {
    setSelectedAccounts([]);
    setStatus(tempStatus);
    setProvider(tempProvider);
    setCampaigns(selectedCampaigns);
    setOpen(false);
  };
  const handleTempClear = () => {
    setTempStatus("all");
    setTempProvider("all");
    setSelectedCampaigns([]);
  };
  const handleClear = () => {
    setSelectedAccounts([]);
    setStatus("all");
    setProvider("all");
    setCampaigns([]);
    setOpen(false);
  };
  useEffect(() => {
    if (!open) return;
    setTempStatus(status);
    setTempProvider(provider);
    setSelectedCampaigns(campaigns);
  }, [open])
  useEffect(() => {
    if (Array.isArray(userCampaigns)) {
      // const filteredCampaigns = userCampaigns?.filter(
      //   (campaign) => !campaign?.archived
      // );
      // const filteredArchiveCampaigns = userCampaigns?.filter(
      //   (campaign) => campaign?.archived
      // );
      // const combinedCampaigns = [
      //   ...filteredCampaigns,
      //   ...filteredArchiveCampaigns,
      // ];
      setaiAgents([...userCampaigns]);
    } else {
      setaiAgents([]);
    }
  }, [userCampaigns]);
  useEffect(() => {
    if (!open) return;

    setUserCampaignsLoading(true);
    jobsApi
      .getUserCampaigns(user?.email, "", 0, 0, "all", "", "", "_id, status2, responsibility, archived")
      .then((res) => {
        if (Array.isArray(res?.data)) {
          const mappedCampaigns = res?.data?.map((camp) => ({
            _id: camp?._id,
            responsibility: camp?.responsibility,
            archived: camp?.archived,
            status2: camp?.status2
          }));
          setUserCampaigns(mappedCampaigns);
        }
        setUserCampaignsLoading(false);
      })
      .catch((error) => {
        setUserCampaignsLoading(false);
      });
  }, [open]); // Changed dependency from [] to [open]
  const filterCount = (status !== "all" ? 1 : 0) + (provider !== "all" ? 1 : 0) + campaigns?.length;
  const tempFiltersCount = (tempStatus !== "all" ? 1 : 0) + (tempProvider !== "all" ? 1 : 0) + selectedCampaigns?.length

  return (
    <>
      <Button
        variant="outlined"
        className="glass-button-secondary-50"
        onClick={handleOpen}
        startIcon={<FilterAltOutlined />}
        endIcon={filterCount > 0 ? (
          <Chip
            size="small"
            color="primary"
            label={<span style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: 1 }}>{filterCount} <CloseOutlined sx={{ fontSize: "16px" }} /></span>}
            sx={{ "& .MuiChip-label": { fontSize: "14px" } }}
            onClick={(e) => {
              e.stopPropagation();
              handleClear()
            }}
          />
        ) : <></>}
      >
        Filters
      </Button>
      {/* <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
      > */}
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        sx={{
          zIndex: 1300,
          overflow: "hidden",
        }}
        PaperProps={{
          sx: {
            width: { sm: "100%", md: "50%", lg: "30%" },
            padding: 0,
            pt: 0,
            marginTop: "12px",
            height: "calc(100% - 12px)",
            overflow: "hidden",
            borderTopLeftRadius: "8px",
            boxShadow: "0px 4px 40px 0px rgba(0, 0, 0, 0.7)",
            display: "flex",
            flexDirection: "column",
          },
          className: "glass-popup",
        }}
      >
        {/* <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center"
          }}
        > */}
        <Box
          sx={{
            p: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h6"
            component="div"
            fontWeight="bold"
            sx={{ color: (theme) => theme.palette.text.primary }}
          >
            Filters
          </Typography>
          <IconButton onClick={handleClose}>
            <CloseOutlined sx={{ color: theme.palette.text.primary }} />
          </IconButton>
        </Box>
        {/* </DialogTitle> */}

        {/* <DialogContent> */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            px: 2,
          }}
        >
          <Stack spacing={2}>
            <Stack
              spacing={1}
              sx={{
                // remove focus effect
                width: "100%",
                "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                {
                  borderColor: "transparent",
                },
              }}
            >
              <InputLabel id="demo-simple-select-label">
                Connection Status
              </InputLabel>
              <Select
                value={tempStatus}
                onChange={handleStatusChange}
                size="small"
                className="glass-dropdown"
                renderValue={(selected) => (
                  <Chip
                    label={selected}
                    sx={{ textTransform: "capitalize" }}
                    className="glass-tag"
                    size="small"
                  />
                )}
              >
                {/* <MenuItem value={"all"}>All</MenuItem>
                <MenuItem value={"connected"}>Connected</MenuItem>
                <MenuItem value={"disconnected"}>Disconnected</MenuItem> */}
                {statusOptions?.map((option) => <MenuItem key={option.label} value={option.value}>{option.label}</MenuItem>)}
              </Select>
            </Stack>

            <Stack
              spacing={1}
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                },
              }}
            >
              <InputLabel>Provider</InputLabel>
              <Select
                label="Provider"
                value={tempProvider}
                onChange={handleProviderChange}
                size="small"
                className="glass-dropdown"
                renderValue={(selected) => (
                  <Chip
                    label={selected}
                    sx={{ textTransform: "capitalize" }}
                    className="glass-tag"
                    size="small"
                  />
                )}
              >
                {providerOptions?.map((option) => <MenuItem key={option.label} value={option.value}>{option.label}</MenuItem>)}
              </Select>
            </Stack>
            {/* <Stack
              spacing={1}
              sx={{
                width: "100%",
                "& .MuiOutlinedInput-root": {
                  "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                    borderColor: "transparent",
                  },
                },
              }}
            >
              <InputLabel>Source</InputLabel>
              <Select
                label="Source"
                value={source}
                onChange={handleSourceChange}
                size="small"
                className="glass-dropdown"
                renderValue={(selected) => (
                  <Chip
                    label={selected}
                    sx={{ textTransform: "capitalize" }}
                    className="glass-tag"
                    size="small"
                  />
                )}
              >
                <MenuItem value="all">All</MenuItem>
                <MenuItem value="dfy">DFY</MenuItem>
                <MenuItem value="standard">Standard</MenuItem>
              </Select>
            </Stack> */}
            <Stack spacing={1}>
              <InputLabel>Campaigns</InputLabel>
              <Autocomplete
                fullWidth
                multiple
                id="checkboxes-tags-demo"
                size="small"
                limitTags={2}
                options={
                  [
                    {
                      responsibility: "All AI Agent",
                      selectAll: true,
                      archived: "",
                    },
                    ...(aiAgents || []),
                  ] || []
                }
                disableCloseOnSelect
                getOptionLabel={(option) => option.responsibility}
                renderOption={(props, option) => {
                  const { color: chipColor, classes } = colorCodes?.getColorCodes(option?.status2)
                  return (
                    <li
                      key={option?._id}
                      {...props}
                      style={{ fontFamily: "Inter", fontSize: "14px", display: "flex", justifyContent: "space-between", alignItems: "center", gap: 1 }}
                    >
                      <Stack flexDirection={"row"} justifyContent={"flex-start"} alignItems={"center"} gap={1}>
                        <CustomCheckBox
                          style={{ marginRight: 8 }}
                          checked={selectedCampaigns.some((item) =>
                            option.selectAll
                              ? selectedCampaigns.length === userCampaigns?.length
                              : item._id === option._id
                          )}
                        />
                        <Typography
                          sx={{
                            flexShrink: 0,
                            maxWidth: 200,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                            fontSize: "14px",
                            fontWeight: 500,
                            color: (theme) => theme.palette.text.primary,
                          }}
                          title={option.responsibility}
                        >
                          {option.responsibility}
                        </Typography>
                      </Stack>
                      {!option?.selectAll &&
                        <Chip
                          label={option?.status2 || "N/A"}
                          sx={{
                            fontSize: "14px",
                            marginRight: "5px",
                            height: "25px",
                            backgroundColor: chipColor,
                            color: "#fff",
                            flexShrink: 0,
                          }}
                          className={classes.chip}
                        />}
                    </li>
                  )
                }}
                style={{
                  minWidth: "160px",
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    paddingRight: "65px",
                    height: "auto",
                    minHeight: "40px",
                    maxHeight: "120px",
                    overflow: "auto",
                    "& .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#E0E0E0",
                    },
                    "& .MuiAutocomplete-endAdornment": {
                      right: "8px",
                      position: "absolute",
                      top: "8px",
                      paddingLeft: "8px",
                    },
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "#f1f1f1",
                      borderRadius: "3px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#888",
                      borderRadius: "3px",
                      "&:hover": {
                        background: "#757575",
                      },
                    },
                  },
                  "& .MuiAutocomplete-tag": {
                    margin: "2px",

                    maxWidth: "calc(100% - 20px)",
                  },
                  "& .MuiInputBase-root": {
                    display: "flex",
                    flexWrap: "wrap",
                    alignContent: "flex-start",
                  },
                  "& .MuiAutocomplete-inputRoot": {
                    flexWrap: "wrap",
                  },
                  "& .MuiAutocomplete-input": {
                    width: "0",
                    minWidth: "30px",
                    flexGrow: 1,
                  },
                }}
                value={selectedCampaigns}
                onChange={handleCampaignChange}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    variant="outlined"
                    className="glass-input"
                    placeholder="Select campaigns"
                    PopperProps={{
                      style: {
                        overflowY: "auto",
                      },
                    }}
                    InputProps={{
                      ...params.InputProps,
                      sx: {
                        height: "42px",
                        paddingLeft: "12px",
                      },
                    }}
                    style={{
                      minHeight: "30px",
                      width: "100%",
                    }}
                  />
                )}
              />
            </Stack>
          </Stack>
          {/* </DialogContent> */}
        </Box>

        {/* <DialogActions sx={{ p: 2, px: 3, justifyContent: "space-between" }}> */}
       
        <Box
          sx={{
            p: 2,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
          }}
        >

          {/* <Typography
            sx={{
              fontSize: "12px",
              fontWeight: 500,
              color: (theme) => theme.palette.text.secondary,
              lineHeight: "18px",
            }}
          >
            <Link
              href={`${HELP_URL}/11142827-manage-linkedin-account#h_226cfbfb31`}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                fontSize: "12px",
                fontWeight: 600,
                color: (theme) => theme.palette.primary.main,
                textDecoration: "none",
                "&:hover": {
                  textDecoration: "underline",
                },
              }}
            >
              Learn
            </Link>{" "}
            to quickly narrow results with filters.
          </Typography> */}
          <HelperLink
            helperText={"Learn to quickly narrow results with filters. "}
            actionText={"Learn more"}
          />

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              gap: 2,
            }}
          >
            <Button
              onClick={handleTempClear}
              variant="outlined"
              fullWidth
              className="glass-button-secondary-50"
              disabled={tempFiltersCount === 0}
            >
              Clear All
            </Button>

            <Button
              onClick={handleApply}
              variant="contained"
              fullWidth
            >
              Show Results
            </Button>
          </Box>

        </Box>
        {/* </DialogActions> */}
      </Drawer>
      {/* </Dialog> */}
    </>
  );
};

export default Filters;
